import styled from 'styled-components';

import { Text } from 'apps/auth/components/common/Text/Text';
import media from 'apps/auth/theme/media';

export const AmountCurrencyLabel = styled.label`
    display: flex;
    align-items: center;
    width: 124px;
    justify-content: flex-end;
    padding: 16px 16px 16px 8px;
    box-sizing: border-box;

    ${media.desktop1440} {
        width: 140px;
    }

    ${media.desktop1920} {
        padding: 20px 24px 20px 16px;
    }
`;
export const AmountCurrencyFlag = styled.div`
    flex-shrink: 0;
`;

export const AmountCurrencyText = styled(Text)`
    margin: 0 4px 0 8px;
    width: 40px;
    flex-shrink: 0;
    text-align: center;

    ${media.desktop1440} {
        width: 52px;
    }
`;
